import { render, staticRenderFns } from "./ListBrokersFiltered.vue?vue&type=template&id=4f1b3529"
import script from "./ListBrokersFiltered.vue?vue&type=script&lang=js"
export * from "./ListBrokersFiltered.vue?vue&type=script&lang=js"
import style0 from "./ListBrokersFiltered.vue?vue&type=style&index=0&id=4f1b3529&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QItemSection,QItemLabel,QSeparator,QTooltip});
